import React from 'react';
import { EmployeeTypes } from 'types';

const mapRawData = (rawData: EmployeeTypes.IEmployees): EmployeeTypes.IEmployeesMapped => {
    const mappedData = {
        staffContacts: rawData.staffContacts.map((staffContact) => {
            return {
                fullName: staffContact.fullName,
                imageUrl: staffContact.imageUrl,
                jobTitle: staffContact.jobTitle,
                phone: staffContact.phone,
                email: staffContact.email,
            };
        }),
        facets: rawData.facets.map((facet) => {
            return {
                key: facet.key,
                name: facet.name,
                values: facet.values.map((value) => {
                    return {
                        key: value.key,
                        count: value.count,
                        name: value.name,
                        available: true,
                    };
                }),
            };
        }),
        usedFilters: {
            BlockContentGuid: rawData.usedFilters.blockContentGuid ?? '',
            PageContentGuid: rawData.usedFilters.pageContentGuid ?? '',
            BusinessUnits: rawData.usedFilters.businessUnits ? rawData.usedFilters.businessUnits[0] ?? null : null,
            Locations: rawData.usedFilters.locations ? rawData.usedFilters.locations[0] ?? null : null,
            Offices: rawData.usedFilters.offices ? rawData.usedFilters.offices[0] ?? null : null,
            Professions: rawData.usedFilters.professions ? rawData.usedFilters.professions[0] ?? null : null,
        },
    };

    mappedData.facets.map((facet) => {
        return facet.values.unshift({ key: '', count: 1, name: facet.name, available: true });
    });

    return mappedData;
};

export default mapRawData;
